import { createElement, Fragment } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { toggleFormat } from '@wordpress/rich-text';
import { RichTextToolbarButton, RichTextShortcut, __unstableRichTextInputEvent } from '@wordpress/block-editor';
import { formatBold } from '@wordpress/icons';
const name = 'core/bold';

const title = __('Bold');

export const bold = {
  name,
  title,
  tagName: 'strong',
  className: null,

  edit(_ref) {
    let {
      isActive,
      value,
      onChange,
      onFocus
    } = _ref;

    function onToggle() {
      onChange(toggleFormat(value, {
        type: name,
        title
      }));
    }

    function onClick() {
      onChange(toggleFormat(value, {
        type: name
      }));
      onFocus();
    }

    return createElement(Fragment, null, createElement(RichTextShortcut, {
      type: "primary",
      character: "b",
      onUse: onToggle
    }), createElement(RichTextToolbarButton, {
      name: "bold",
      icon: formatBold,
      title: title,
      onClick: onClick,
      isActive: isActive,
      shortcutType: "primary",
      shortcutCharacter: "b"
    }), createElement(__unstableRichTextInputEvent, {
      inputType: "formatBold",
      onInput: onToggle
    }));
  }

};
//# sourceMappingURL=index.js.map